import React  from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import NewsLetterBasicInfoComponent from './news-letter-basic-info.component';


export const NewsLetterComponent = ({mediaFiles,handleFormItemChange,deleteSelectedFile,getIsImageRecordDeletable,changeImage, handleInnerFormChange, selectedNewsLetter,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'NewsLetter Information',
        component:<NewsLetterBasicInfoComponent handleInnerFormChange={handleInnerFormChange}
        selectedNewsLetter={selectedNewsLetter}
        mediaFiles={mediaFiles}
        handleFormItemChange={handleFormItemChange}
        changeImage={changeImage}
        deleteSelectedFile={deleteSelectedFile}
        getIsImageRecordDeletable={getIsImageRecordDeletable}
         />,
    isVisible:true,
    },
    
  ]
    
  return (
    <>   
      <TabContainer tabItems={tabItems} />
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       
    </>
  )
}
export default NewsLetterComponent;
